module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center",
    attrs: {
      "id": "epigraph"
    }
  }, [_c('span', [_c('i', [_vm._v("See, I have this special responsibility to my kids. Because to them I’m not just some actor playing Uncle Chubby. I AM Uncle Chubby. And that means a lot to me. Heck, that means everything.")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("—from an interview with Lyle Hudnut in "), _c('i', [_vm._v("TV Guide")]), _vm._v(", two weeks before his arrest")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_c('i', [_vm._v("Nobody ever drowned in shallow.")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("—old sitcom writers’ saying")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6757b723","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/5epigraph.vue
// module id = 75
// module chunks = 0